export default function initAccordions() {
    const accordions = document.querySelectorAll('.accordion');
    accordions.forEach((accordion) => {
        const accordionHeader = accordion.querySelector('.accordion-header');
        const accordionBody = accordion.querySelector('.accordion-body');

        accordionHeader.addEventListener('click', () => {
            accordion.classList.toggle('active');
        });
    });
}